var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrewForAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.56,
    height: 100,
    viewBox: "0 0 155.56 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.073,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07c87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.907,
    y1: 0.115,
    x2: 0.061,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2695",
    "data-name": "Group 2695",
    transform: "translate(-607.465 -150.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(607.465 150.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M91.436-27.662c14.5,4.608,26.846,15.823,33.076,32.883h29.365a1.625,1.625,0,1,1,0,3.248H123.435a1.62,1.62,0,0,1-1.559-1.12C116.062-9.478,104.2-20.107,90.358-24.474S60.519-26.9,46.554-18.1a1.793,1.793,0,0,1-1.364.377,1.793,1.793,0,0,1-1.213-.729,1.736,1.736,0,0,1-.138-1.381,1.736,1.736,0,0,1,.918-1.041,56.3,56.3,0,0,1,46.68-6.789ZM32.473,31.5a1.824,1.824,0,0,1,1.255,1.12C39.482,49.444,51.346,60.131,65.186,64.44c13.9,4.367,29.839,2.421,43.8-6.317a1.653,1.653,0,1,1,1.8,2.714c-14.737,9.268-31.76,11.454-46.616,6.789C49.612,63.018,37.326,51.8,31.1,34.8H1.731A1.745,1.745,0,0,1,0,33.152,1.8,1.8,0,0,1,1.736,31.5Z",
    transform: "translate(0 30)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "np_earth_1219989_000000",
    d: "M39.824,16A23.824,23.824,0,1,0,63.649,39.824,23.824,23.824,0,0,0,39.824,16Zm0,45.544a21.351,21.351,0,0,1-13.8-4.976,24.154,24.154,0,0,0,1.19-4.834c0-1.4-2.8-1.4-3.5-2.1s-.7-2.8-1.4-3.5a15.889,15.889,0,0,0-3.783-1.891,22.563,22.563,0,0,1-.422-4.415A15.638,15.638,0,0,1,18.173,38c1.541-.772,4.834-2.592,4.834-3.082,0-.7-1.4-4.2-1.4-4.9a3.159,3.159,0,0,1,2.1-2.1c.7,0,.7,2.8,1.4,2.8s2.8-4.2,2.8-4.9c0-.63-1.541-2.241-1.963-2.663a21.571,21.571,0,0,1,24.246-2.382C48.933,21.532,46.62,23,46.13,23h-4.2c-.7,0-3.993,3.014-3.5,3.5.7.7,2.8-.7,3.5-.7s.7,2.1,0,2.8-4.9.7-5.605.7-2.1,2.8-2.1,3.5a1.507,1.507,0,0,0,1.4,1.4c.7,0,4.2-2.8,4.9-2.8s2.1,1.4,2.8,1.4,2.8-2.1,3.5-1.4-2.1,2.1-2.1,2.8.7.7,1.4.7.7,1.4,0,1.4h-4.9c-.7,0-1.4-1.4-2.1-1.4s-7.707,2.8-7.707,3.5v4.2c0,.7,2.8,2.8,3.5,2.8s2.1-.7,2.8-.7,2.8,3.5,2.8,4.2-.7,1.4-.7,2.1a5.312,5.312,0,0,0,1.4,2.8c.7.7,2.1,1.4,2.8.7s4.2-4.2,4.2-4.9v-2.1c0-.7,2.452-1.963,2.1-2.8-.211-.49-1.4,0-2.1-.7s-.7-6.306-.7-6.306,1.4,4.2,2.1,4.9,2.8-1.4,2.8-2.1a17.978,17.978,0,0,0-1.4-3.5l1.4,1.4c.7.7,1.4,0,2.1,0s2.1,4.9,2.8,4.9.7-2.1,1.4-2.8c.49-.49,1.891-.63,2.8-.7a21.735,21.735,0,0,1-21.72,21.721Z",
    transform: "translate(645.637 160.673)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrewForAll);
export default __webpack_public_path__ + "static/media/crewForAll.09b916afd2f628c953403590352244b7.svg";
export { ForwardRef as ReactComponent };